// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__C9vZp","cnt":"Banner_cnt__6bkEa"};